<template>
    <div class="attr2xc-dialog">
        <el-dropdown trigger="click" :placement="placement" @command="handleCommand">
            <el-button-group>
              <el-button type="primary" size="medium" @click="wardingResultsTo('top-start')">
                添加到相册
              </el-button>
              <el-button type="primary" size="medium" @click="wardingResultsTo('bottom-end')">
                从相册中移除
              </el-button>
            </el-button-group>
            <el-dropdown-menu slot="dropdown">
                <template v-for="item in wardingResults">
                    <el-dropdown-item :key="item.id" :command="item.id">
                        <span>{{ item.name }}</span>
                    </el-dropdown-item>
                </template>
            </el-dropdown-menu>
          </el-dropdown>
    </div>
</template>

<script>
import Vue from 'vue';
import App from '../../util/comfun'
export default {
    name: 'Attr2xcDialog',
    props: {
        activityId: {
            type: String,
            default: ''
        },
        selectids: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            // Initialize your data properties here
            placement: 'bottom-end',
            wardingResults: [],
        };
    },
    methods: {
        // Define your methods here
        wardingResultsTo(placement) {
            this.placement = placement;
            console.log('Warding results to:', placement);
            // You can add more logic here if needed
        },
        handleCommand(command) {
            console.log('click on item ' + command,this.selectids, this.placement);
            // Handle the command when an item is clicked
            if (!this.selectids || this.selectids.length === 0) {
                this.$message('请先选择要操作的投稿');
                return;
            }
            if (this.placement == 'top-start') {
                App.demand('/submission/wardingResult/addSubmission', 'POST', {
                    isGlobal: 0,
                    submissionIdList: this.selectids,
                    wardingResultId: command,
                }).then(res => {
                    if (res.code == 200) {
                        this.$message('添加成功');
                        this.$emit('event', command);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else if (this.placement == 'bottom-end') {
                App.demand('/submission/wardingResult/delSubmission', 'POST', {
                    isGlobal: 0,
                    submissionIdList: this.selectids,
                    wardingResultId: command,
                }).then(res => {
                    if (res.code == 200) {
                        this.$message('移除成功');
                        this.$emit('event', command);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        }
    },
    mounted() {
        // Lifecycle hook for when component is mounted
        console.log('Attr2xcDialog mounted with activityId:', this.activityId);
        App.demand('/activity/wardingResult/list','GET',{activityId: this.activityId}).then(res => {
            if (res.code == 200) {
                console.log('Data fetched successfully:', res.data);
                this.wardingResults = res.data;
            } else {
                console.error('Error fetching data:', res.message);
            }
        })
    }
};
</script>

<style scoped>
.attr2xc-dialog {
    /* Add your styles here */
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/attr2xc.vue